import React from 'react';
import {
  Image,
  Flex,
  Heading,
  keyframes,
  useColorModeValue,
  VStack,
  Link,
  Icon,
  Text,
  Box,
} from '@chakra-ui/react';
import Tilt from 'react-parallax-tilt';
import { AiFillLinkedin } from 'react-icons/ai';
import { FaGithubSquare } from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';
import profile from '../Images/profile.jpg'

const Profile = () => {
  const colorModeValue = useColorModeValue('#edeeee', '#1b202c');

  const profileLinksColor = useColorModeValue('black', '#c3c6cd');

  const subTitleColor = useColorModeValue('black', '#9ca3af');

  const animate = keyframes`
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 400% 0;
  }
  100% {
    background-position: 0 0;
  }
  `;

  return (
    <Box
      w={['230px', '300px', '400px', '230px', '250px', '250px']}
      h={['100px', '120px', '150px', '100%', '100%', '100%']}
      position={'relative'}
    >
      <Tilt
        glareEnable={false}
        tiltReverse
      >
        <Flex
          background={colorModeValue}
          direction={['row', 'row', 'row', 'column', 'column']}
          justifyContent={[
            'space-between',
            'space-between',
            'space-between',
            null,
            null,
            null,
          ]}
          _before={{
            content: '""',
            position: 'absolute',
            left: '-2px',
            top: '-2px',
            background:
              'linear-gradient(45deg, #e6fb04,#ff6600, #00ff66, #00ffff, #ff00ff, #ff0099, #6e0dd0, #ff3300, #099fff)',
            backgroundSize: '400%',
            width: 'calc(100% + 4px)',
            height: 'calc(100% + 4px)',
            zIndex: '-30',
            animation: `${animate} 20s linear infinite`,
          }}
          _after={{
            content: '""',
            position: 'absolute',
            left: '-2px',
            top: '-2px',
            background:
              'linear-gradient(45deg, #e6fb04,#ff6600, #00ff66, #00ffff, #ff00ff, #ff0099, #6e0dd0, #ff3300, #099fff)',
            backgroundSize: '400%',
            width: 'calc(100% + 5px)',
            height: 'calc(100% + 5px)',
            zIndex: '-30',
            animation:`${animate} 20s linear infinite`,
            filter: 'blur(30px)',
            opacity: '0.9',
          }}
        >
          <Image
            w={['40%', '40%', '40%', '100%', '100%']}
            src={profile}
          />
          <Flex
            direction={'column'}
            py={['5px', '5px', '5px', '30px', '30px', '30px']}
            px={['15px', '15px', '15px', '20px', '30px', '30px']}
          >
            <Heading
              mb={['0.3rem', '0.5rem', '0.8rem', '0.8rem', '0.8rem', '0.8rem']}
              fontWeight={'500'}
              letterSpacing={'1px'}
              fontSize={['10px', '12px', '15px', '20px', '20px', '20px']}
            >
              Lior Reuven
            </Heading>
            <Heading
              fontWeight={'normal'}
              color={subTitleColor}
              fontSize={['9px', '10px', '10px', '15px', '15px', '15px']}
            >
              Full-Stack Web Developer
            </Heading>
            <VStack
              spacing={['5px', '5px', '10px', '15px', '15px', '15px']}
              alignItems={'flex-start'}
              pt={['8px', '10px', '15px', '25px', '25px', '25px']}
              display={'flex'}
              direction={'column'}
              w={'100%'}
            >
              <Link
                as={'a'}
                href={'https://www.linkedin.com/in/liorreuven'}
                target="_blank"
                isExternal
                display={'flex'}
                alignItems={'center'}
              >
                <Icon
                  mr={'0.5rem'}
                  boxSize={['10px', '10px', '15px', '25px', '25px', '25px']}
                  as={AiFillLinkedin}
                ></Icon>
                <Text
                  fontSize={['8px', '10px', '13px', '16px', '16px']}
                  fontWeight={'normal'}
                  color={profileLinksColor}
                >
                  Follow my Linkdin
                </Text>
              </Link>
              <Link
                as={'a'}
                href="https://github.com/LiorReuven"
                target="_blank"
                isExternal
                display={'flex'}
                alignItems={'center'}
              >
                <Icon
                  mr={'0.5rem'}
                  boxSize={['10px', '10px', '15px', '25px', '25px', '25px']}
                  as={FaGithubSquare}
                ></Icon>
                <Text
                  fontSize={['8px', '10px', '13px', '16px', '16px']}
                  fontWeight={'normal'}
                  color={profileLinksColor}
                >
                  My Github
                </Text>
              </Link>
              <Link
                as={'a'}
                target="_blank"
                href="mailto:lior.r.dev@gmail.com"
                isExternal
                display={'flex'}
                alignItems={'center'}
              >
                <Icon
                  mr={'0.5rem'}
                  boxSize={['10px', '10px', '15px', '25px', '25px', '25px']}
                  as={FiMail}
                ></Icon>
                <Text
                  fontSize={['8px', '10px', '13px', '16px', '16px']}
                  fontWeight={'normal'}
                  color={profileLinksColor}
                >
                  lior.r.dev@gmail.com
                </Text>
              </Link>
            </VStack>
          </Flex>
        </Flex>
      </Tilt>
    </Box>
  );
};

export default Profile;
